<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="1024"
    @click:outside="dialog = false"
  >
    <template #activator="{ props }">
      <v-btn color="grey-darken-3" variant="tonal" v-bind="props" class="ml-2"
        >Criar Implementação</v-btn
      >
    </template>

    <v-card>
      <v-card-title>
        <div class="d-flex justify-space-between">
          <span class="text-h5">Criar Implementação</span>
          <v-btn
            variant="plain"
            rounded="xl"
            prepend-icon="mdi-window-close"
            @click="dialog = false"
          ></v-btn>
        </div>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-form ref="form" validate-on="lazy submit">
            <v-row>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="this.tipoImplementacao"
                  label="Tipo Implementação*"
                  :items="tipoImplementacoes"
                  :rules="tipoImplementacaoRules"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="6">
                <v-select
                  v-model="this.prioridade"
                  label="Prioridade da Tarefa*"
                  :items="prioridades"
                  :rules="prioridadeRules"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="6">
                <v-select
                  v-model="this.storypoint"
                  label="Storypoint da Tarefa*"
                  :items="storypoints"
                  :rules="storypointRules"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="6">
                <v-select
                  v-model="this.repositorio"
                  label="Repositorio da Tarefa"
                  :items="repositoriosNome"
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-container>

        <small>*Campo obrigatório</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="blue-darken-1" variant="text" @click="submitForm">
          Salvar
          <v-progress-circular
            v-if="this.isLoading"
            class="ml-2"
            indeterminate
            size="20"
          />
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
/**
 * @module CreateImplementacao
 * @desc Modal para a criação da tarefa de implementação.
 * @vue-data {boolean} [dialog=false] - Flag que indica se o modal
 * está visível.
 * @vue-data {string} [tipoImplementacao=''] - O tipo de implementação
 * selecionado.
 * @vue-data {Array.<string>} tipoImplementacoes - Array com os tipos
 * de implementações possíveis.
 * @vue-data {string} [prioridade=''] - A prioridade selecionada.
 * @vue-data {Array.<string>} prioridades - Array com as prioridades
 * possíveis.
 * @vue-data {string} [storypoint=''] - O storypoint selecionado.
 * @vue-data {Array.<string>} storypoints - Array com os storypoints
 * possíveis.
 * @vue-data {string} idProjeto - O id do projeto.
 * @vue-data {boolean} [isLoading=false] - Flag que indica se a
 * tarefa de implementação está sendo criada.
 */
import axios from 'axios';

import store from '@/store/store';
const apiUrl = process.env.VUE_APP_API_URL;

export default {
  props: {
    id: Number,
  },
  data: () => ({
    dialog: false,
    tipoImplementacao: '',
    tipoImplementacoes: ['Funcionalidade', 'Teste automatizado'],
    prioridade: '',
    prioridades: ['Urgente', 'Alta', 'Média', 'Baixa'],
    storypoint: '',
    storypoints: ['1', '2', '3', '5', '8', '13', '20', '?'],
    repositorio: '',
    repositorios: [],
    repositoriosNome: [],
    idRepositorio: null,
    idProjeto: null,
    isLoading: false,
    tipoImplementacaoRules: [(v) => !!v || 'Tipo implementação é obrigatório'],
    prioridadeRules: [(v) => !!v || 'Prioridade é obrigatória'],
    storypointRules: [(v) => !!v || 'Storypoint é obrigatório'],
  }),
  created() {
    this.idProjeto = this.$route.params.idProjeto;
    this.buscarRepositorios();
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    /**
     * Formata as strings do enum;
     */
    converterEnumParaTexto(string) {
      /// PRIORIDADE
      if (string === 'URGENTE') {
        return 'Urgente';
      } else if (string === 'ALTA') {
        return 'Alta';
      } else if (string === 'MEDIA') {
        return 'Média';
      } else if (string === 'BAIXA') {
        return 'Baixa';
      }
      /// TIPO
      if (string === 'FUNCIONALIDADE') {
        return 'Funcionalidade';
      } else if (string === 'TESTE_AUTOMATIZADO') {
        return 'Teste automatizado';
      }
    },
    /**
     * Formata as strings do enum;
     */
    converterTextoParaEnum(string) {
      /// PRIORIDADE.
      if (string === 'Urgente') {
        return 'URGENTE';
      } else if (string === 'Alta') {
        return 'ALTA';
      } else if (string === 'Média') {
        return 'MEDIA';
      } else if (string === 'Baixa') {
        return 'BAIXA';
      }
      /// TIPO.
      if (string === 'Funcionalidade') {
        return 'FUNCIONALIDADE';
      } else if (string === 'Teste automatizado') {
        return 'TESTE_AUTOMATIZADO';
      }
    },
    /**
     * Lida com o evento de pressionar tecla. Se a tecla pressionada for ESC,
     * o modal é fechado.
     *
     * @param {Object} event Objeto do evento
     */
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.dialog = false;
      }
    },

    /**
     * Realiza requisição HTTP para buscar os repositorios do projeto.
     */
    async buscarRepositorios() {
      const response = await axios.get(
        `${apiUrl}/projetos/${this.idProjeto}/repositorios/`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        },
      );
      this.repositorios = response.data;
      this.repositoriosNome = this.repositorios.map(
        (repositorio) => repositorio.tb_repositorio.nome,
      );
    },

    // busca id do repositorio a partir do repositorio selecionado.
    buscarIdRepositorio() {
      const repositorio = this.repositorios.find(
        (repositorio) => repositorio.tb_repositorio.nome == this.repositorio,
      );
      this.idRepositorio = repositorio.tb_repositorio.id_repositorio;
    },

    /**
     * Realiza requisição HTTP para criar a tarefa de implementação.
     */
    async submitForm() {
      const isValid = (await this.$refs.form.validate()).valid;
      if (isValid) {
        this.isLoading = true;
        const csu = await axios.get(
          `${apiUrl}/api/v1/productBacklog/${this.id}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );

        this.buscarIdRepositorio();
        const casoDeUsoNome = csu.data.useCase.nome;
        const dataTarefa = {
          titulo: `implementacao do caso de uso : ${casoDeUsoNome}`, // eslint-disable-line
          descricao: 'a editar',
          storypoint: this.storypoint,
          prioridade: this.converterTextoParaEnum(this.prioridade),
          tipo_tarefa: 'IMPLEMENTACAO', // eslint-disable-line
          id_projeto: parseInt(this.idProjeto), // eslint-disable-line
          id_dev: parseInt(this.id_usuario), // eslint-disable-line
          id_repo: parseInt(this.idRepositorio), // eslint-disable-line
        };

        try {
          const config = {
            headers: { Authorization: `Bearer ${store.state.token}` },
          };
          const responseTarefa = await axios.post(
            apiUrl + '/tarefas/criar',
            dataTarefa,
            config,
          );
          const idTarefa = parseInt(responseTarefa.data.resposta.id_tarefa);
          const data = {
            // eslint-disable-next-line camelcase
            id_caso_de_uso: parseInt(this.id),
            // eslint-disable-next-line camelcase
            tipo_implementacao: this.converterTextoParaEnum(
              this.tipoImplementacao,
            ),
            // eslint-disable-next-line camelcase
            id_tarefa: idTarefa,
          };
          await axios.post(`${apiUrl}/api/v1/implementacao/unico/`, data, {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          });
          await axios.patch(
            `${apiUrl}/api/v1/productBacklog/status/${this.id}`,
            {
              status: 'EM_IMPLEMENTACAO',
            },
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`,
              },
            },
          );
          location.reload();
        } catch (error) {
          console.log(error);
        } finally {
          this.dialog = false;
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
